import React from 'react';
import RecurringTitle from './RecurringTitle';
import CheckoutPlanSelect from './CheckoutPlanSelect';

import './style.scss';

const CheckoutPlans = () => (
    <div className="checkout-plans">
        <RecurringTitle/>
        <CheckoutPlanSelect/>
    </div>
);

export default CheckoutPlans;
